exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_headerColumn__22CvW:first-child{width:18.75rem!important}.style_rowColumn__13kPZ{word-break:normal;white-space:normal;padding:0 1.125rem!important;vertical-align:middle!important}.style_rowColumn__13kPZ p{margin:.5rem 0}.style_center__2WdKe{text-align:center}", ""]);

// exports
exports.locals = {
	"headerColumn": "style_headerColumn__22CvW",
	"rowColumn": "style_rowColumn__13kPZ",
	"center": "style_center__2WdKe"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/OpenFeatureDialog/style.less
// module id = 1980
// module chunks = 8